import { render } from "./OModal.vue?vue&type=template&id=6171a4f2&scoped=true"
import script from "./OModal.vue?vue&type=script&lang=js"
export * from "./OModal.vue?vue&type=script&lang=js"

import "./OModal.vue?vue&type=style&index=0&id=6171a4f2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6171a4f2"]])

export default __exports__